import React, { Component } from 'react';
import { FormGroup, ControlLabel, Checkbox, Radio } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { CCOAlert, FieldGroup, TimePicker, CustomButtomView, LocationPicker } from '../../util/Components.js';
import { clone, setSubState } from '../../util/Utility.js';
import PanelEditView from '../../model/PanelEditView.js';


// var equipmentRoomMap = {
//   c: { summary: "There are already speakers in the Lobby, Sanctuary, and Fellowship Hall.  Choose from the options below if you need special setup, or specify if you need audio or video in any other rooms.", options: ["Syncronized Audio w/ Wireless Mic", "Audio Outside"]},
//   s: { summary: "There is a full speaker system and a projector for video.  If you need a specialized audio setup (specific instruments) on stage, please specify.", options: ["Audio Recording", "Video Streaming"]},
//   h: { summary: "There is a full speaker system and a projector for video.  If you need a specialized audio setup (specific instruments) on stage, please specify.", options:["Audio Recording", "Video Streaming", "Use X-Air"]},
//   m: { summary: "There is no audio or video equipment in this room, please check anything you will need", options: ["Speakers", "Microphone", "Music Plugin", "Projector", "Computer"]},
//   f: { summary: "There is a basic speaker system and a projector for video.  If you need any instuments plugged in or a better sound board, please specify", options: ["Use X-Air", "iPad for Lyrics"]},
//   k: { summary: "There is a basic speaker system and a projector for video,  If you need any specialized equipment, note below", options: ["Audio Recording", "Use X-Air"]}
// }

var eventTechSetup = [
  { title: "Recording & Streaming", options: ["Audio Recording", "Audio & Video Recording", "Video Recording & Streaming"] },
  { title: "Sound Amplification", options: ["Mic & Speakers", "Wireless Mic & Speakers"] },
  { title: "Projection", options: ["Laptop Plugin to Projector", "Church-Provided Laptop & Projector"]},
  { title: "Worship", options: ["Plugin for Guitar & Vocal", "Plugin for Guitar & Vocal AND Overhead Lyric Projection", "Plugin for Multiple Instruments and Vocals (Specified Below)", "Plugin for Multiple Instruments and Vocals (Specified Below) AND Overhead Lyric Projection"]}
]

var eventRoomSetup = [
  { title: "Chair Arrangement", options: ["Chairs in Rows", "Chairs & Rectangular Tables in Rows", "Chairs around Circular Tables"] }
]

export default class EditEventView extends Component {

  constructor(props) {
    super(props);

    this.defaultObject = {
      title: "",
      location: "f",
      atCCO: true,
      date: moment().hour(18).startOf('hour').unix(),
      endDate: moment().hour(20).startOf('hour').unix(),
      description: "",
      ministryID: this.props.ministry ? this.props.ministry.key : -1,
      originator: this.props.user.uid,
      approver1: null,
      approval2: null,
      verse: null,
      additionalButtons: null,
      setupNotes: "",
      show: false,
      type: false,
      action: "none",
      wholeChurch: false
    };

    let object = props.new ? clone(this.defaultObject) : clone(this.props.object);

    this.state = {
      object: object,
      differentEndDate: !moment.unix(object.date).isSame(moment.unix(object.endDate), 'day'),
      titleAlert: false,
      locationAlert: false,
      endDateAlert: false,
      directionsAlert: false,
      customButtonAlert: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.new !== this.props.new || newProps.show !== this.props.show || (newProps.object && this.props.object && newProps.object.key !== this.props.object.key) || (newProps.ministry && this.props.ministry && this.props.ministry.key !== newProps.ministry.key)) {
      if (newProps.new) {
        let object = clone(this.defaultObject);
        object.ministryID = newProps.ministry.key;
        this.setState({object, differentEndDate: false});
      } else {
        this.setState({object: clone(newProps.object), differentEndDate: !moment.unix(newProps.object.date).isSame(moment.unix(newProps.object.endDate), 'day')});
      }
    }
  }

  dismissAlerts() {
    this.setState({titleAlert: false, locationAlert: false, endDateAlert: false, directionsAlert: false, customButtonAlert: false});
  }

  saveCheck() {
    var object = this.state.object;
    this.setState({titleAlert: false, locationAlert: false, directionsAlert: false, customButtonAlert: false});
    return new Promise((resolve, reject) => {
      let good = true;  
      if (object.title === "" || object.description === "") {
        this.setState({titleAlert: true});
        good = false;
      }
      if (object.location === "") {
        this.setState({locationAlert: true});
        good = false;
      }
      if (!object.atCCO && !object.directionsAvailable && !this.state.directionsAlert) {
        this.setState({directionsAlert: true});
        good = false;
      }
      if (this.customButton.getCurrentEntry().title.length > 0 || this.customButton.getCurrentEntry().link.length > 0) {
        this.setState({customButtonAlert: true});
        good = false;
      }
      if (object.description.indexOf("http") > 0) {
        good = false;
      }
      
      if (good) {
        resolve(object);
      } else {
        reject();
      }
    });
  }

  render() {

    return (
      <PanelEditView title="Event" object={this.state.object} saveButtonTitle={this.props.new ? "Save as Draft" : null} setState={this.setState.bind(this)} dismissAlerts={this.dismissAlerts.bind(this)} defaultObject={this.defaultObject} saveCheck={this.saveCheck.bind(this)} {...this.props}>
        <FieldGroup id="title" label="Title" placeholder="Enter text" context={this} comp="object" />
        <LocationPicker comp="object" context={this} showLabel />

        <FieldGroup id="description" label="Description" placeholder="Enter Text"  context={this} comp="object" componentClass="textarea" />
        <CCOAlert in={this.state.object.description && this.state.object.description.indexOf("http") > 0} type="danger" title="Links used in Description" content="Links used in the description will not be clickable, please use custom buttons instead." />

        <FormGroup controlId="date">
          <ControlLabel>{this.state.differentEndDate ? "Start Date" : "Date"}</ControlLabel><br />
          <Datetime open={true} timeFormat={false} value={moment.unix(this.state.object.date)} input={false} onChange={function(e) {
            var obj = this.state.object;
            obj.date = e.minute(0).second(0).unix();
            if (!this.state.differentEndDate) obj.endDate = e.minute(0).second(0).add(2, 'hours').unix();
            this.setState({object: obj});
          }.bind(this)} />
        </FormGroup>

        <FormGroup controlId="endDateOption">
          <Checkbox checked={this.state.differentEndDate} onChange={() => {
            if (this.state.differentEndDate) {
              var obj = this.state.object;
              obj.endDate = moment.unix(obj.endDate).dayOfYear(moment.unix(obj.date).dayOfYear()).unix();
              if (obj.endDate < obj.date)
                obj.endDate = moment.unix(obj.date).add(1, 'hours').unix();
              this.setState({object: obj});
            }
            this.setState({differentEndDate: !this.state.differentEndDate});
          }}>Event Ends on a Different Date</Checkbox>
        </FormGroup>

        {this.state.differentEndDate && <FormGroup controlId="date">
          <ControlLabel>End Date</ControlLabel><br />
          <Datetime open={true} timeFormat={false} value={moment.unix(this.state.object.endDate)} input={false} onChange={function(e) {
            var obj = this.state.object;
            let endDate = e.minute(0).second(0).unix();
            if (endDate < obj.date) this.setState({endDateAlert: true});
            else {
              obj.endDate = e.minute(0).second(0).unix();
              this.setState({object: obj, endDateAlert: false});
            }
          }.bind(this)} />
        </FormGroup>}

        <CCOAlert in={this.state.endDateAlert} type="danger" title="Bad Date" content="The end date cannot be before the start date." />

        <TimePicker comp="object" context={this} />

        <ControlLabel>User Action</ControlLabel>
        <FormGroup>
          <Radio key="none" checked={this.state.object.action === 'none'} name="action" onChange={() => setSubState(this, "object", "action", "none")}>None</Radio>
          <Radio key="rsvp" checked={this.state.object.action === 'rsvp'} name="action" onChange={() => {
            setSubState(this, "object", "action", "rsvp");
            setSubState(this, "object", "rsvpFormFields", { phone: 15 });
            setSubState(this, "object", "emailUpdates", true);
          }}>RSVP</Radio>
          <Radio key="register" checked={this.state.object.action === 'register'} name="action" onChange={() => {
            setSubState(this, "object", "action", "register");
            setSubState(this, "object", "emailUpdates", true);
          }}>Register</Radio>
        </FormGroup>
        {this.state.object.action !== 'none' && 
        <Checkbox checked={this.state.object.emailUpdates} onChange={() => {
          setSubState(this, "object", "emailUpdates", !this.state.object.emailUpdates);
        }}>Receive email notifications for each RSVP/Registration</Checkbox>}

        {this.state.object.ministryID !== "cco" && <div>
          <ControlLabel>Audience</ControlLabel>
          <FormGroup>
            <Radio key="followers" checked={!this.state.object.wholeChurch} name="Audience" onChange={() => setSubState(this, "object", "wholeChurch", false)}>Followers of this ministry</Radio>
            <Radio key="all" checked={this.state.object.wholeChurch} name="Audience" onChange={() => setSubState(this, "object", "wholeChurch", true)}>Entire Congregation (Only for events the entire congregation is invited to)</Radio>
          </FormGroup>
        </div>}

        {this.state.object.atCCO && <div>

          <div style={{height: 15}} />
          <h4>Room Setup</h4>
          {eventRoomSetup.map((item, i) => {
            return (
              <div key={i}>
                <div style={{height: 10}} />
                <ControlLabel>{item.title}</ControlLabel>
                <FormGroup>
                  <Radio key="none" checked={this.state.object.roomSetup === undefined || this.state.object.roomSetup[item.title] === undefined} name={item.title} onChange={() => {
                    let object = this.state.object;
                    delete object.roomSetup[item.title];
                    this.setState({object});
                  }}>None</Radio>
                  {item.options.map((option, i) => <Radio
                    key={i}
                    checked={this.state.object.roomSetup && this.state.object.roomSetup[item.title] === option}
                    name={item.title}
                    onChange={() => {
                      let object = this.state.object;
                      if (object.roomSetup === undefined) {
                        object.roomSetup = {};
                      }
                      object.roomSetup[item.title] = option;
                      this.setState({object});
                    }}>
                    {option}
                  </Radio>)}
                </FormGroup>
              </div>
            )
          })}

          <div style={{height: 15}} />
          <h4>Technical Setup</h4>
          {eventTechSetup.map((item, i) => {
            return (
              <div key={i}>
                <div style={{height: 10}} />
                <ControlLabel>{item.title}</ControlLabel>
                <FormGroup>
                  <Radio key="none" checked={this.state.object.techSetup === undefined || this.state.object.techSetup[item.title] === undefined} name={item.title} onChange={() => {
                    let object = this.state.object;
                    delete object.techSetup[item.title];
                    this.setState({object});
                  }}>None</Radio>
                  {item.options.map((option, i) => <Radio
                    key={i}
                    checked={this.state.object.techSetup && this.state.object.techSetup[item.title] === option}
                    name={item.title}
                    onChange={() => {
                      let object = this.state.object;
                      if (object.techSetup === undefined) {
                        object.techSetup = {};
                      }
                      object.techSetup[item.title] = option;
                      this.setState({object});
                    }}>
                    {option}
                  </Radio>)}
                </FormGroup>
              </div>
            )
          })}



          <FieldGroup id="setupNotes" label="Additional Setup Notes" placeholder="Enter Text" context={this} comp="object" componentClass="textarea" />
        </div>}

        <CustomButtomView
          buttons={this.state.object.buttons}
          addButton={newButton => {
            let event = this.state.object;
            if (event.buttons)
              event.buttons.push(newButton);
            else
              event.buttons = [newButton];
            this.setState({object: event});
          }}
          removeButton={index => {
            let event = this.state.object;
            event.buttons.splice(index, 1);
            this.setState({object: event});
          }}
          ref={ref => this.customButton = ref}
        />

        <div style={{height: 10}} />

        {this.props.new && <center><p>Note: You can publish this event after you save it as a draft and review the details.</p></center>}
        <CCOAlert in={this.state.titleAlert} type="danger" title="Blank Fields" content="Please enter a Title and Description" />
        <CCOAlert in={this.state.locationAlert} type="danger" title="Blank Fields" content="Please either select a room (for events at CCO) or a location." />
        <CCOAlert in={this.state.directionsAlert} type="warning" title="Unknown Location" content="When typing a location into the text box, please select an option from the dropdown.  If the location does not show in the dropdown and you want to save anyway, just click save again, but note that directions will not be available through the app for this event." />
        <CCOAlert in={this.state.customButtonAlert} type="warning" title="Unsaved Custom Button" content="Press the check button to the right of the custom button details in order to add it to this event." />

      </PanelEditView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/events/EditEventView.js
 **/